<template>
  <section class="video-cap-container" v-if="isValid">
    <div v-if="!(isFinished && !isUploading && uploadUrl)">
      Take a clear Video of your ID
    </div>
    <div v-if="isFinished && !isUploading && uploadUrl">
      Check the video – does it show your face and your ID from different
      angles?
    </div>
    <div v-show="!isUploading" class="stream-container">
      <video ref="videoRec" class="camera" muted loop controls autoplay />
      <div></div>
      <template v-if="!isFinished">
        <button v-if="!isRecording" @click="record" class="btn flex-center">
          {{ recordBtnContent }}
        </button>
        <button v-else @click="stop" class="btn">
          <span style="font-size: 3em">{{ stopBtnContent }}</span>
        </button>
      </template>
    </div>
    <Loader v-show="isUploading" />
    <div class="controls" v-if="isFinished && !isUploading && uploadUrl">
      <button type="button" class="btn" @click.prevent="resetVideo">
        {{ cancelBtnContent }}
      </button>
      <button type="button" class="btn" @click.prevent="done">
        {{ doneBtnContent }}
      </button>
    </div>
    <h1 class="error-video">{{ errText }}</h1>
  </section>
</template>

<script>
import Loader from "./Loader.vue";

export default {
  name: "VideoCapture",
  props: {
    uploadUrl: {
      default: null,
    },
    recordBtnContent: {
      default: "Record",
    },
    stopBtnContent: {
      default: "◼",
    },
    cancelBtnContent: {
      default: "Cancel",
    },
    doneBtnContent: {
      default: "OK",
    },
  },
  components: {
    Loader,
  },
  data() {
    return {
      errText: null,
      isValid: true,
      isUploading: false,
      isRecording: false, // recording mode identifier
      isFinished: false, // finished recording - action buttons indicator
      recorder: null, // component wide MediaRecorder
      connection: null, // component wide WebSocket
      videoUrl: null, // link to video - assigned when done writing video file
      stream: null,
    };
  },
  created() {
    if (!this.uploadUrl) this.errText = "There is no upload url available";
    this.getWebSocket(); // initialize connection to WebSocket
  },
  mounted() {
    this.resetVideo();
  },
  methods: {
    // reset video display with media device media stream
    resetVideo() {
      this.isFinished = false;
      this.isRecording = false;
      this.isLoading = true;
      this.$refs.videoRec.muted = true;
      navigator.mediaDevices
        .getUserMedia({
          video: {
            width: { ideal: 1920 },
            height: { ideal: 1080 },
          },
          audio: false,
        })
        .then(this.gotStream)
        .catch(() => (this.isValid = false));
    },
    // start recoording
    record() {
      if (!this.uploadUrl) return;
      this.recorder.start();
      this.isRecording = true;
    },
    // stop recording
    stop() {
      this.recorder.stop();
      this.isRecording = false;
      this.isFinished = true;
      this.connection.send("DONE");
    },
    // reset video diaply and emit video file url
    done() {
      //   this.resetVideo();
      //   this.$emit("input", this.videoUrl);
      this.$router.push({ name: "ValidEmail" });
    },
    // initialize MediaRecorder and video element source
    gotStream(mediaStream) {
      this.stream = mediaStream;
      this.recorder = new MediaRecorder(mediaStream, {
        mimeType: "video/webm",
        audioBitsPerSecond: 128000,
      });
      this.recorder.ondataavailable = this.videoDataHandler;
      this.$refs.videoRec.src = null;
      this.$refs.videoRec.srcObject = mediaStream;
      this.toggleVideo();
    },
    // handle sending data for writing using the given WebSocket
    videoDataHandler(event) {
      this.isUploading = true;
      let reader = new FileReader();
      reader.readAsArrayBuffer(event.data);
      reader.onloadend = () => {
        this.connection.send(reader.result);
      };
    },
    // initialize WebSocket
    getWebSocket() {
      const websocketEndpoint = "wss://" + this.uploadUrl;
      this.connection = new WebSocket(websocketEndpoint);
      this.connection.binaryType = "arraybuffer";
      this.connection.onmessage = (message) => {
        this.updateVideoFile(message.data);
        this.$refs.videoRec.muted = false;
      };
    },
    // update video when file written
    updateVideoFile(fileName) {
      this.videoUrl = `https://${this.uploadUrl}/uploads/${fileName}.webm`;
      this.toggleVideo();
      this.$refs.videoRec.srcObject = null;
      this.$refs.videoRec.src = this.videoUrl;
      this.isUploading = false;
    },
    // toggle video display
    toggleVideo() {
      this.$refs.videoRec.loop = !this.$refs.videoRec.loop;
      this.$refs.videoRec.controls = !this.$refs.videoRec.controls;
    },
  },
  destroyed() {
    this.stream.getTracks().forEach(function (track) {
      track.stop();
    });
  },
};
</script>

<style>
/* .f_letter {
  font-size: large;
} */
</style>